import { useState, type ReactNode } from 'react';

interface Props {
  title: string;
  badge?: string;
  /** Contenu affiché quand la section est repliée */
  collapsedHint?: string;
  /** Ouverte au chargement (défaut: false) */
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
}

/** Carte repliable (même motif que les synthèses Conception / Planification). */
export function CollapsibleCard({
  title,
  badge,
  collapsedHint,
  defaultOpen = false,
  children,
  className = '',
}: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={`u-card u-synth-section${open ? ' is-open' : ' is-collapsed'}${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="u-synth-section-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className="u-synth-section-toggle-main">
          <span className="u-synth-chevron" aria-hidden>
            {open ? '▼' : '▶'}
          </span>
          <span>
            <strong>{title}</strong>
            {badge ? <span className="u-synth-section-count">{badge}</span> : null}
          </span>
        </span>
        <span className="u-synth-section-hint">{open ? 'Replier' : 'Déplier'}</span>
      </button>
      {open ? (
        children
      ) : collapsedHint ? (
        <p className="muted u-synth-collapsed-hint">{collapsedHint}</p>
      ) : null}
    </section>
  );
}
